import { gql } from '@apollo/client';

const GET_API_HOOK_URLS = gql`
    query GetApiHookUrls($profileId: Int!) {
        getApiHookUrls(profileId: $profileId) {
            production {
                pdfDownloadUrl
                pdfReadyNotificationUrl
                questionnaireCompleteNotificationUrl
                questionnaireCompleteUrl
                questionnaireExitUrl
            }
            test {
                pdfDownloadUrl
                pdfReadyNotificationUrl
                questionnaireCompleteNotificationUrl
                questionnaireCompleteUrl
                questionnaireExitUrl
            }
        }
    }
`;

export default GET_API_HOOK_URLS;
